import React, { useState, useEffect } from "react";
// import Api from "../../../../../services/ServiceApi";
import Cookies from "js-cookie";

import { Table } from "antd";

const AddBusTable = ({  setBookedData, setBookedAmount, busesData , setSelectedRowBus }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [busData, setBusData] = useState();
  // const [bookedAmount, setBookedAmount] = useState(0);
  const [filteredData, setFilteredData] = useState([]);

  // let data_bus = busesData
  useEffect(() => {
    /*Api.post("getListBus", {
      // "license_plate":"16กฉ-2386",
      // "bus_line_id" : 1,
      // "garage_id" : 1,
      model_id: 1,
      // "bus_group_id" : 1,
      // "bus_type_id" : 1,
      // "bus_status" : "1",
      // "remark" : "",
      // "2D" : "1",
      // "3D" : "1",
      // "FW" : "1",
      // "HG" : "1",
      // "HW" : "1",
      // "IB" : "1",
      LED: "1",
      // "QW" : "1",
      // "LCD" : "1",
      // "Reflective_film" : "1",
      // "has_bus_patent" : "1",
      // "has_contract" : "1",
      // "sub_status" : "locked"
    }).then((res) => {
      console.log("res from list bus", res);
      setBusData(res.data.data);
    });*/

    setBusData(busesData);

    console.log('AddBusTable data_bus',busesData);

    /*data_bus.map((item, index) => {

      if(item.fw === true){
        item.externalFW = item.fW_advertise_list_id
      }
      if(item.hw === true){
        item.externalHW = item.hW_advertise_list_id
      }
      if(item.qw === true){
        item.externalQW = item.qW_advertise_list_id
      }

      if(item.external_ad_start !== "" && item.external_ad_start !== null){
        item.externalStartDate = item.external_ad_start
      }
      if(item.external_ad_end !== "" && item.external_ad_end !== null){
        item.externalExpiredDate = item.external_ad_end
      } 

      if(item.hg === true){
        item.hangar = item.hG_advertise_list_id
      }
      if(item.lcd === true){
        item.LCD = item.lcD_advertise_list_id
      }

      if(item.internal_ad_start !== "" && item.internal_ad_start !== null){
        item.internalStartDate = item.internal_ad_start
      }
      if(item.internal_ad_end !== "" && item.internal_ad_end !== null){
        item.internalExpiredDate = item.internal_ad_end
      }

      if(item["2D"] === true){
        item.two_d = 1
      }
      if(item["3D"] === true){
        item.three_d = 1
      }
      if(item["led"] === true){
        item.lightning = 1
      }
      if(item["reflective_film"] === true){
        item.reflectiveFilms = 1
      }
      
    })
    */

    setFilteredData(busesData);


  }, [busesData]);

  // useEffect(() => {

  //   setFilteredData(busesData);
  //   console.log('useEffect busesData',busesData);

  // }, {busesData});

  useEffect(() => {
    setBookedAmount(selectedRowKeys.length);
  }, [selectedRowKeys.length]);

  const columns = [
    {
      title: "Plate No.",
      dataIndex: "license_plate",
      key: "license_plate",
      render: (plateNO) => (
        <span className="c-blue text-underline">{plateNO}</span>
      ),
    },
    {
      title: "Line No.",
      dataIndex: "bus_line_name",
      key: "bus_line_name",
    },
    {
      title: "Area",
      dataIndex: "area_name",
      key: "area_name",
    },
    {
      title: "Division",
      dataIndex: "division_name",
      key: "division_name",
    },
    {
      title: "Garage",
      dataIndex: "garage_name",
      key: "garage_name",
    },
    {
      title: "Bus No.",
      dataIndex: "bus_no",
      key: "bus_no",
    },
    {
      title: "Model",
      dataIndex: "model_name",
      key: "model_name",
    },
    {
      title: "Bus Group",
      dataIndex: "bus_group_name",
      key: "bus_group_name",
    },
    {
      title: "Bus Type",
      dataIndex: "bus_type_name",
      key: "bus_type_name",
    },
    {
      title: "Media ID",
      dataIndex: "media_id",
      key: "media_id",
    },
  ];
  // const data = [
  //   {
  //     plateNO: "16-2390",
  //     lineNO: "MA List",
  //     area: 3,
  //     division: 2,
  //     garage: "ฟาร์มจระเข้",
  //     busNO: 70380,
  //     model: "BLK01",
  //     busGroup: "สัมปทาน",
  //     busType: "SLK",
  //     mediaID: "Bus 2774",
  //   },
  //   {
  //     plateNO: "16-2391",
  //     lineNO: "MA List",
  //     area: 3,
  //     division: 2,
  //     garage: "ฟาร์มจระเข้",
  //     busNO: 70380,
  //     model: "BLK01",
  //     busGroup: "สัมปทาน",
  //     busType: "SLK",
  //     mediaID: "Bus 2774",
  //   },
  //   {
  //     plateNO: "16-2392",
  //     lineNO: "MA List",
  //     area: 3,
  //     division: 2,
  //     garage: "ฟาร์มจระเข้",
  //     busNO: 70380,
  //     model: "BLK01",
  //     busGroup: "สัมปทาน",
  //     busType: "SLK",
  //     mediaID: "Bus 2774",
  //   },
  // ];
  function bookingBus() {
    const bookedData = JSON.parse(Cookies.get('booked_data'))
    console.log('booked Data', bookedData)

    /*Api.post("addBusBooking", {
      bus_array: [1, 7],
      // booking_code: "B_A000002",
      // customer: "Mikku",
      booking_code: bookedData.bookedID,
      customer: bookedData.customer,
      advertise_list_code: "A_A000001",
    }).then((res) => {
      console.log(res.data.result.description)
    });*/
  };

  const onSelectChange = (tempRowKeys, tempRows) => {
    setSelectedRowKeys(tempRowKeys);
    setSelectedRows(tempRows);
    setSelectedRowBus(tempRows)
    // selectedRowKeys and selectedRows จะlog ช้ากว่า 1 step จากที่กด
    console.log(tempRowKeys, tempRows);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <React.Fragment>
      
      {/* <Table
        columns={columns}
        dataSource={filteredData}
        size="middle"
        rowSelection={rowSelection}
        rowKey="license_plate"
      /> */}

    <Table
      // rowKey="asset_id"
      columns={columns}
      dataSource={filteredData}
      rowSelection={rowSelection}
      rowKey="license_plate"
      // scroll={{ x: 3000 }}
    />
    </React.Fragment>
  );
};

export default AddBusTable;
